// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dynamicMessage__dynamicMessagePermission___1NYEE{font-size:14px;text-align:center;-webkit-font-smoothing:antialiased;opacity:0.8}\n", ""]);
// Exports
exports.locals = {
	"dynamicMessagePermission": "dynamicMessage__dynamicMessagePermission___1NYEE"
};
module.exports = exports;
